exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":host {\n    background-color: #F0F0F0;\n    display: block;\n    /* height: 100px; */\n}\n.ship-popup-wrapper {\n    padding: 15px;\n}\n\n::ng-deep .ship-popup-wrapper lfwms-result-data-table .lfwms-hdr-checkbox {\n    display: none;\n}\n/*\n::ng-deep .ship-popup-wrapper lfwms-result-data-table .header-content .icon-sort {\n    display: none;\n}\n\n\n::ng-deep .ship-popup-wrapper lfwms-result-data-table .header-content .ag-header-row {\n    \n}\n*/\n.ship-button {\n    margin-left:20px;\n}\n.detail-back-container {\n    background: #F0F0F0;\n    padding-top: 10px;\n    padding-left: 22px;\n}\n.lbl-back-prop {\n    display: inline-block;\n    margin-left: 10px;\n    margin-right: 10px;\n    color: #12408B;\n    position: relative;\n    bottom: 3px;\n}\n.forward-backward-icon {\n    cursor: pointer;\n    font-size: 20px;\n    color: #12408B; \n    margin-left: 18px;   \n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/1_SCE_CI_CD_SIT/src/app/shared/lookup/ship-ref-popup/show_mbol_error_popup/show-mbol-error-log-popup.component.css
// module id = ../../../../../src/app/shared/lookup/ship-ref-popup/show_mbol_error_popup/show-mbol-error-log-popup.component.css
// module chunks = main